import AdminHeading from "Components/Pages/AdminPanel/Heading/AdminHeading";
import React, { useEffect, useMemo, useState } from "react";
import styles from "./addStockLabelledUnlabelled.module.css";
import AdminBreadCrump from "Components/Pages/AdminPanel/Heading/AdminBreadCrump";
import ErrorModal from "Components/Other Functions/popup";
import AlertMessage from "Components/Other Functions/AlertMessage";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import GetApiService from "Components/Api/getapiService";
import { useSelector } from "react-redux";
import {
  AddStockFields,
  AddStockFieldsNew,
  AddStocklooseDiamondNewFields,
  AddStockNormalFieldsNew,
  AddStockUnlabelledFieldsNew,
} from "./addstock";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import {
  generateDropDownList,
  getDropDownListAddStock,
  looseDiamondId,
  selectStyle,
  selectStylee,
} from "utils/helpers";
import { useQuery } from "@tanstack/react-query";
import { fetchBranchList, fetchVendorsList } from "services/invoiceServices";
import { Check, FileDownload, FileUpload, Refresh } from "@mui/icons-material";
import Spinner from "Components/CommonComponents/Spinner";
import { Icon } from "@iconify/react";
import { fetchSKUList } from "services/skus";
import StockForm from "Components/AddStock/StockForm";
import {
  fetchAllBoxes,
  fetchAllCollection,
  fetchAllPackets,
} from "services/other";
import StockTable from "Components/AddStock/StockTable";
import { fetchVendorTouncheList } from "services/Tounches";
import ImportPopup from "Components/AddStock/ImportPopup";
import { BsFileArrowDown, BsFileArrowDownFill } from "react-icons/bs";
import { fetchLotList } from "services/purchaseServices";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaCheck } from "react-icons/fa";

const defaultValues = {
  StockType: {
    label: "Labelled",
    value: "Labelled",
  },
  VendorId: "",
  SKUId: "",
  LotNumber: "",
  Branch: "",
  Quantity: "1",
  TotalWeight: "",
  PackingWeight: "",
  GrossWt: "",
  TotalStoneWeight: "",
  NetWt: "",
  Pieces: "",
  MakingPercentage: "",
  MakingPerGram: "",
  MakingFixedAmt: "",
  MakingFixedWastage: "",
  MRP: "",
  ClipWeight: "",
  ClipQuantity: "",
  ProductName: "",
  Description: "",
  DiamondShape: "",
  DiamondClarity: "",
  DiamondColour: "",
  DiamondSize: "",
  DiamondSleve: "",
  DiamondWeight: "",
  DiamondSellRate: "",
  DiamondPieces: "",
  DiamondCut: "",
  DiamondSettingType: "",
  DiamondCertificate: "",
  DiamondDescription: "",
  FinePercent: "",
  WastagePercent: "",
  FineWastage: "",
  StoneName: "",
  StoneColor: "",
  StoneShape: "",
  StoneSize: "",
  StoneWeight: "",
  StonePieces: "",
  StoneRatePiece: "",
  StoneRateKarate: "",
  StoneAmount: "",
  StoneDescription: "",
  StoneCertificate: "",
  StoneSettingType: "",
};
const AddStockLabelledUnlabelled = () => {
  const navigate = useNavigate()
  const allStates = useSelector((state) => state);
  const [searchParams, setSearchParams] = useSearchParams();
  const [stockType, setStockType] = useState(
    searchParams.get("stockType") || ""
  );

  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const EmployeeCode = adminLoggedIn.EmployeeId;
  const apiService = new GetApiService(clientCode);
  const apifields = useMemo(
    () =>
      adminLoggedIn.Modules.filter(
        (module) => module.PageName === "add_bulk_stock_new"
      ),
    [adminLoggedIn]
  );
  const localfields = useMemo(() => toPlainFields(AddStockNormalFieldsNew), []);
  const localUnlabelledFields = useMemo(
    () => toPlainFields(AddStockUnlabelledFieldsNew),
    []
  );
  const apifieldsControls = useMemo(
    () => apifields[0]?.PageControls || [],
    [apifields]
  );
  const localfieldsLooseDiamonds = useMemo(() => toPlainFields(AddStocklooseDiamondNewFields), []);
 
  console.log(apifieldsControls)
  const [itemfields, setItemfields] = useState(() => {
    const updatedFields = localfields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) =>
          apiField.key === localField.key && apiField.place === localField.place
      );
      if (matchingApiField) {
        if (
          matchingApiField?.key === "StockType" &&
          matchingApiField?.place === "top"
        ) {
          return {
            ...localField,
            label: localField.label,
            placeholder: matchingApiField.placeholder,
            priority: matchingApiField.priority,
            type: localField.type,
            visibility: matchingApiField.visibility,
            place: matchingApiField.place,
            value: "Labelled",
          };
        }

        return {
          ...localField,
          label: localField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: localField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
          value: "",
        };
      }
      return localField;
    });
    return updatedFields;
  });
  const [itemfieldsLooseDiamonds, setItemfieldsLooseDiamonds] = useState(() => {
    const updatedFields = localfieldsLooseDiamonds.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) =>
          apiField.key === localField.key && apiField.place === localField.place
      );
      if (matchingApiField) {
        if (
          matchingApiField?.key === "StockType" &&
          matchingApiField?.place === "top"
        ) {
          return {
            ...localField,
            label: localField.label,
            placeholder: matchingApiField.placeholder,
            priority: matchingApiField.priority,
            type: localField.type,
            visibility: matchingApiField.visibility,
            place: matchingApiField.place,
            value: "Labelled",
          };
        }

        return {
          ...localField,
          label: localField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: localField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
          value: "",
        };
      }
      return localField;
    });
    return updatedFields;
  });
  const [itemUnlabelledFields, setItemUnlabelledFields] = useState(() => {
    const updatedFields = localUnlabelledFields.map((localField) => {
      return {
        ...localField,
        label: localField.label,
        placeholder: localField.placeholder,
        priority: localField.priority,
        type: localField.type,
        visibility: localField.visibility,
        place: localField.place,
        value: "",
      };
    });
    return updatedFields;
  });

  const fetchAllData = async () => {
    try {
      const [
        allSku,
        categories,
        productTypes,
        designs,
        purities,
        diamondAttributes,
        stoneAttributes,
      ] = await Promise.allSettled([
        apiService.fetchAllSku(),
        apiService.fetchAllCategories(),
        apiService.fetchAllProductType(),
        apiService.fetchAllDesigns(),
        apiService.fetchAllPurities(),
        apiService.fetchAllDiamondAttributes(),
        apiService.fetchAllStoneAttributes(),
      ]);

      // Check the results of each promise and handle errors if any
      const results = {
        allSku: allSku.status === "fulfilled" ? allSku.value : null,
        categories: categories.status === "fulfilled" ? categories.value : null,
        productTypes:
          productTypes.status === "fulfilled" ? productTypes.value : null,
        designs: designs.status === "fulfilled" ? designs.value : null,
        purities: purities.status === "fulfilled" ? purities.value : null,
        diamondAttributes:
          diamondAttributes.status === "fulfilled"
            ? diamondAttributes.value
            : null,
        stoneAttributes:
          stoneAttributes.status === "fulfilled" ? stoneAttributes.value : null,
      };

      // Log and handle any rejected promises (optional)
      const failedPromises = [
        allSku,
        categories,
        productTypes,
        designs,
        purities,
        diamondAttributes,
        stoneAttributes,
      ].filter((result) => result.status === "rejected");

      if (failedPromises.length > 0) {
        failedPromises.forEach((failedPromise) => {
          console.error(`Failed to fetch data: ${failedPromise.reason}`);
        });
      }

      return results;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw new Error(`Failed to fetch dropdown list data: ${error.message}`);
    }
  };

  const {
    data: dropdownListData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["/add_stock_labelled_unlabelled/allData"],
    queryFn: fetchAllData,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 1,
    staleTime: 1000 * 60 * 1,
  });
  const { data: allCollections } = useQuery({
    queryKey: ["/add_stock_labelled_unlabelled/fetchAllCollection", clientCode],
    queryFn: fetchAllCollection,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 1,
    staleTime: 1000 * 60 * 1,
  });
  const { data: allPackets } = useQuery({
    queryKey: ["/add_stock_labelled_unlabelled/fetchAllPackets", clientCode],
    queryFn: fetchAllPackets,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 1,
    staleTime: 1000 * 60 * 1,
  });
  const { data: allBoxes } = useQuery({
    queryKey: ["/add_stock_labelled_unlabelled/fetchAllBoxes", clientCode],
    queryFn: fetchAllBoxes,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 1,
    staleTime: 1000 * 60 * 1,
  });

  const { data: branchOption, refetch: RefetchbranchOption } = useQuery({
    queryKey: ["/add_stock_labelled_unlabelled/getAllBranchList", clientCode],
    queryFn: fetchBranchList,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 1,
    staleTime: 1000 * 60 * 1,
  });
  const { data: vendorList, refetch: RefetchVendorList } = useQuery({
    queryKey: ["/add_stock_labelled_unlabelled/getAllVendorList", clientCode],
    queryFn: fetchVendorsList,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 1,
    staleTime: 1000 * 60 * 1,
  });
  const {
    data: vendorTounchList,
    isLoading: vendorTounchListIsLoading,
    isError: vendorTounchIsError,
    refetch: vendorTounchRefetch,
  } = useQuery({
    queryKey: ["addStock/getVendorTounchList", clientCode],
    queryFn: fetchVendorTouncheList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const { data: skuList, refetch: RefetchSkuList } = useQuery({
    queryKey: ["/add_stock_labelled_unlabelled/fetchSKUList", clientCode],
    queryFn: fetchSKUList,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 1,
    staleTime: 1000 * 60 * 1,
  });

  const { data: LotList, refetch: RefetchRDPurchaseList } = useQuery({
    queryKey: ["/add_stock_labelled_unlabelled/fetchRDPurchase", clientCode],
    queryFn: fetchLotList,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 1,
    staleTime: 1000 * 60 * 1,
  });

  const [fields, setFields] = useState([]);

  const [showError, setShowError] = useState(false);
  const [skus, setSkus] = useState([]);
  const [stockData, setStockData] = useState({Quantity:1});
  const [excelResponse, setExcelResponse] = useState([]);
  const [isDataFromExcel, setIsDataFromExcel] = useState(false);
  const [isFileUploadPopUp, setIsFileUploadPopUp] = useState(false);
  const [mainStoneList, setMainStoneList] = useState([]);
  const [weightCategoryList, setWeightCategoryList] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });
  const SKUId = watch("SKUId");
  const Vendor = watch("VendorId");
  const CategoryId = watch("CategoryId");
  const ProductId = watch("ProductId");
  const DesignId = watch("DesignId");
  const PurityId = watch("PurityId");
  const TotalWeight = watch("TotalWeight");
  const PackingWeight = watch("PackingWeight");
  const GrossWt = watch("GrossWt");
  const TotalStoneWeight = watch("TotalStoneWeight");
  const LotNumber = watch("LotNumber");
  const LanyardWeight = watch("LanyardWeight");
  const FindingWeight = watch("FindingWeight");
  const TagWeight = watch("TagWeight");
  const PouchWeight = watch("PouchWeight");
  const OtherWeight = watch("OtherWeight");
  const ClipWeight = watch("ClipWeight");
  const Quantity = watch("Quantity");
  const mainstone = watch("mainstone");
  const Pieces = watch("Pieces");
  const DiamondName = watch("DiamondName");
  const DiamondSellRate = watch("DiamondSellRate");
  const Weight = watch("Weight");

  const DiamondWeight = watch("DiamondWeight");
  const FinePercentage = watch("FinePercentage");
  const WastagePercentage = watch("WastagePercentage");
  const NetWt = watch("NetWt");
  console.log(mainstone);

    
  useEffect(()=>{
   
    if(CategoryId?.value == looseDiamondId){
      setFields(itemfieldsLooseDiamonds)
    }else{
      setFields(itemfields)
    }

},[itemfields,itemfieldsLooseDiamonds,CategoryId])

  useEffect(()=>{
    if(dropdownListData?.productTypes?.length){
      const foundProduct = dropdownListData?.productTypes?.find((item)=>item?.Id == DiamondName?.value)
      if(foundProduct?.Id){
        setValue("DiamondShape",{value:foundProduct?.Shape,label:foundProduct?.ShapeName})
        setValue("DiamondColour",{value:foundProduct?.Color,label:foundProduct?.ColorName})
        setValue("DiamondClarity",{value:foundProduct?.Clarity,label:foundProduct?.ClarityName})
      }else{
        setValue("DiamondShape","")
        setValue("DiamondColour","")
        setValue("DiamondClarity","")
      }
    }
  },[DiamondName,dropdownListData])

  useEffect(()=>{
    setValue("DiamondAmount",(+(DiamondSellRate) || 0) * (+(DiamondWeight) || 0))
  },[DiamondSellRate,DiamondWeight])
  
  useEffect(()=>{
    
    if(LotList?.length && LotNumber){
      const found = LotList?.find((item)=>item?.LotNumber == LotNumber?.label)
      console.log(found)
      console.log(LotList)
      console.log(LotNumber)
      setValue("Weight",((+(found?.TotalNetWt) || 0) || (+(found?.TotalDiamondNetWt) || 0))?.toFixed(3))
    }else{
      setValue("Weight","")
    }
  },[LotNumber,LotList])
  useEffect(() => {
    if (branchOption?.length) {
      setValue("Branch", {
        value: branchOption[0]?.Id,
        label: branchOption[0]?.BranchName,
      });
    }
  }, [branchOption]);
  useEffect(() => {
    if (skuList?.length && Vendor?.value) {
      // setValue("SKUId", "");
      const filtered = skuList?.filter(
        (item) => item?.VendorId == Vendor?.value
      );
      if (filtered?.length) {
        setSkus(filtered);
      } else {
        setSkus([]);
      }
    } else {
      setSkus(skuList);
    }
  }, [skuList, Vendor]);

  useEffect(() => {
    if (SKUId?.value) {
      const foundSku = skuList?.find((item) => item?.Id === SKUId?.value);
      let packingWt = 0;
      if (+(foundSku?.ClipWeight || 0))
        packingWt += +(foundSku?.ClipWeight || 0);
      if (+(foundSku?.LanyardWeight || 0))
        packingWt += +(foundSku?.LanyardWeight || 0);
      if (+(foundSku?.PouchWeight || 0))
        packingWt += +(foundSku?.PouchWeight || 0);
      if (+(foundSku?.TagWeight || 0)) packingWt += +(foundSku?.TagWeight || 0);
      if (+(foundSku?.FindingWeight || 0))
        packingWt += +(foundSku?.FindingWeight || 0);
      if (+(foundSku?.OtherWeight || 0))
        packingWt += +(foundSku?.OtherWeight || 0);

      if (foundSku) {
        const fields = {
          CategoryId: +(foundSku?.CategoryId || 0) && {
            value: foundSku.CategoryId,
            label: foundSku.CategoryName,
          },
          ProductId: +(foundSku?.ProductId || 0) && {
            value: foundSku.ProductId,
            label: foundSku.ProductName,
          },
          DesignId: +(foundSku?.DesignId || 0) && {
            value: foundSku.DesignId,
            label: foundSku.DesignName,
          },
          PurityId: +(foundSku?.PurityId || 0) && {
            value: foundSku.PurityId,
            label: foundSku.PurityName,
          },
          CollectionId: +(foundSku?.CollectionId || 0) && {
            value: foundSku.CollectionId,
            label: foundSku.CollectionName,
          },
          BoxId: +(foundSku?.BoxId || 0) && {
            value: foundSku.BoxId,
            label: foundSku.BoxName,
          },
          Quantity: foundSku.Quantity,
          TotalWeight: packingWt
            ? (+(foundSku.GrossWt || 0) + packingWt)?.toFixed(3)
            : (+(foundSku.GrossWt || 0))?.toFixed(3),
          TotalStoneWeight: foundSku.TotalStoneWeight,
          Pieces: foundSku.Pieces,
          MakingPercentage: foundSku.MakingPercentage,
          MakingPerGram: foundSku.MakingPerGram,
          MakingFixedAmt: foundSku.MakingFixedAmt,
          MakingFixedWastage: foundSku.MakingFixedWastage,
          MRP: foundSku.MRP,
          ClipWeight: foundSku.ClipWeight,
          OtherWeight: foundSku.OtherWeight,
          PouchWeight: foundSku.PouchWeight,
          TagWeight: foundSku.TagWeight,
          FindingWeight: foundSku.FindingWeight,
          LanyardWeight: foundSku.LanyardWeight,
          Description: foundSku.Description,
          Gender: foundSku.Gender,
          Size: foundSku.Size,
        };
        Object.entries(fields).forEach(([key, value]) =>
          setValue(key, value || "")
        );
        if (foundSku?.SKUStoneMain?.length) {
          setMainStoneList(foundSku.SKUStoneMain);
        }
        if (foundSku?.WeightCategories && foundSku?.WeightCategories != "0") {
          const list = foundSku?.WeightCategories?.split(",")?.map((item) => {
            return { value: item, label: item };
          });
          console.log(list);
          setWeightCategoryList(list);
        }
      }
    } else {
      const emptyFields = [
        "CategoryId",
        "ProductId",
        "DesignId",
        "PurityId",
        "CollectionId",
        "BoxId",
        "Quantity",
        "TotalWeight",
        "TotalStoneWeight",
        "Pieces",
        "MakingPercentage",
        "MakingPerGram",
        "MakingFixedAmt",
        "MakingFixedWastage",
        "MRP",
        "ClipWeight",
        "OtherWeight",
        "PouchWeight",
        "TagWeight",
        "FindingWeight",
        "LanyardWeight",
        "Description",
        "Gender",
        "Size",
      ];

      emptyFields.forEach((key) =>
        key == "Quantity" ? setValue(key, "1") : setValue(key, "")
      );
      setMainStoneList([]);
      setWeightCategoryList([]);
    }
  }, [SKUId?.value, skuList, setValue]);

  useEffect(() => {
    let packingWt = 0;
    if (+(ClipWeight || 0)) packingWt += +(ClipWeight || 0);
    if (+(LanyardWeight || 0)) packingWt += +(LanyardWeight || 0);
    if (+(PouchWeight || 0)) packingWt += +(PouchWeight || 0);
    if (+(TagWeight || 0)) packingWt += +(TagWeight || 0);
    if (+(FindingWeight || 0)) packingWt += +(FindingWeight || 0);
    if (+(OtherWeight || 0)) packingWt += +(OtherWeight || 0);

    setValue("PackingWeight", (+(packingWt || 0))?.toFixed(3));
  }, [
    LanyardWeight,
    FindingWeight,
    TagWeight,
    PouchWeight,
    OtherWeight,
    ClipWeight,
  ]);

  useEffect(() => {
    setValue(
      "GrossWt",
      (+(TotalWeight || 0) - +(PackingWeight || 0))?.toFixed(3)
    );
  }, [TotalWeight, PackingWeight]);

  useEffect(() => {
    setValue(
      "NetWt",
      (
        +(GrossWt || 0) -
        +(TotalStoneWeight || 0) -
        +(DiamondWeight || 0)
      )?.toFixed(3)
    );
  }, [GrossWt, TotalStoneWeight, DiamondWeight]);

  useEffect(() => {
    let fineWastageWt =
      +(NetWt || 0) * (+(FinePercentage || 0) / 100) +
      +(NetWt || 0) * (+(WastagePercentage || 0) / 100);
    setValue("FineWastageWt", (fineWastageWt || 0)?.toFixed(3));
  }, [WastagePercentage, FinePercentage, NetWt]);

  useEffect(() => {
    if (mainstone?.value) {
      const foundSku = skus?.find((item) => item?.Id == SKUId?.value);
      const foundStone = foundSku?.SKUStoneMain?.find(
        (item) => item?.Id == mainstone?.value
      );
      setValue(
        "TotalStoneWeight",
        ((+foundStone?.StoneMainWeight || 0) * (+Pieces || 1))?.toFixed(3)
      );
      setValue(
        "TotalStoneAmount",
        ((+foundStone?.StoneMainAmount || 0) * (+Pieces || 1))?.toFixed(2)
      );
      setValue("Stones", [
        {
          StoneName: foundStone?.StoneMainName,
          StoneColour: "",
          StoneShape: "",
          StoneSize: "",
          StoneWeight: (+foundStone?.StoneMainWeight || 0)?.toFixed(3),
          StonePieces: foundStone?.StoneMainPieces,
          StoneRatePiece: "",
          StoneRateKarate: (+foundStone?.StoneMainRate || 0)?.toFixed(2),
          Description: foundStone?.StoneMainDescription,
          StoneAmount: (+foundStone?.StoneMainAmount || 0)?.toFixed(2),
          StoneStatusType: "deduct",
        },
      ]);
    }
  }, [mainstone, Pieces]);

  const handleAddSku = () => {
    handleSubmit(onSubmit)();
  };

  const onSubmit = async (data) => {
    if (!+(data?.Quantity || 0)) {
      toast.error("Please select quantity");
    } else {
      setStockData(data);
      const emptyFields = [
        "VendorId",
        "SKUId",
        "LotNumber",

        "CategoryId",
        "ProductId",
        "DesignId",
        "PurityId",
        "CollectionId",
        "PacketId",
        "BoxId",
        "mainstone",
        "WeightCategory",
        "Quantity",
        "TotalWeight",
        "PackingWeight",
        "GrossWt",
        "TotalStoneWeight",
        "NetWt",
        "Pieces",
        "MakingPercentage",
        "MakingPerGram",
        "MakingFixedAmt",
        "MakingFixedWastage",
        "MRP",
        "ClipWeight",

        "ClipQuantity",
        "ProductName",
        "Description",
        "Gender",
      ];
      emptyFields.forEach((key) => setValue(key, ""));
      setMainStoneList([]);
      setWeightCategoryList([]);
    }
  };

  return (
    <div>
      <div>
        {isFileUploadPopUp && (
          <ImportPopup
            isOpen={isFileUploadPopUp}
            onClose={() => setIsFileUploadPopUp(false)}
            itemfields={fields}
            Vendor={Vendor}
            skus={skus}
            setExcelResponse={setExcelResponse}
            categories={
              dropdownListData?.categories?.length
                ? dropdownListData?.categories
                : []
            }
            productTypes={
              dropdownListData?.productTypes?.length
                ? dropdownListData?.productTypes
                : []
            }
            designs={
              dropdownListData?.designs?.length ? dropdownListData?.designs : []
            }
            purities={
              dropdownListData?.purities?.length
                ? dropdownListData?.purities
                : []
            }
            vendorList={vendorList?.length ? vendorList : []}
            clientCode={clientCode}
            setIsDataFromExcel={setIsDataFromExcel}
            
          />
        )}
        <AdminHeading />
        <>
          <div>
            <ErrorModal
              isOpen={false}
              onRequestClose={() => {
                // setShowModal(false);
                // navigate("/adminhome");
              }}
              //   onReload={reloadData} // Pass reload function
              //   message={errorMessage}
            />

            <div className="adminMainBodyBox">
              {showError ? (
                <AlertMessage
                //  message={messageToShow}
                //   type={messageType}
                />
              ) : null}
            </div>
          </div>
        </>
        <AdminBreadCrump
          title={`${"Add Stock"}`}
          companyName={"Loyalstring"}
          module={"Transactions"}
          page={`${"Add Stock"}`}
        />
      </div>

      <form className={styles.mainbox}>
        {/* ---- top section ----- */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            paddingLeft: "14px",
            paddingTop: "20px",
            paddingBottom: "20px",
          }}
        >
          <label style={{ display: "flex" }}>
            <input
              type="radio"
              name="stockType"
              value="Labelled"
              checked={stockType === "Labelled"}
              onChange={(e) => setSearchParams({ stockType: e.target.value })}
            />
            Labelled
          </label>

          <label style={{ display: "flex" }}>
            <input
              type="radio"
              name="stockType"
              value="Unlabelled"
              checked={stockType === "Unlabelled"}
              onChange={(e) => setSearchParams({ stockType: e.target.value })}
            />
            Unlabelled
          </label>
        </div>

        {/* <div className={styles.linesection}>
          <div className={styles.container}>
            {(stockType == "Labelled"
              ? itemfields
              : stockType == "Unlabelled"
              ? itemUnlabelledFields
              : []
            )
              ?.filter(
                (field) =>
                  field?.place === "top" &&
                  field.visibility !== "Hidden" &&
                  field.IsVisible !== "Hidden"
              )
              .sort((a, b) => a.priority - b.priority)
              .map((field, index) => (
                <>
                  <div className={styles.box}>
                    <label>
                      {field?.label}
                      {field?.mandatory && (
                        <span style={{ color: "red", marginLeft: "2px" }}>
                          *
                        </span>
                      )}
                    </label>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "2px",
                      }}
                    >
                      <div style={{ flex: "6" }}>
                        {field.type === "" ? (
                          <input
                            type="text"
                            name={field.key}
                            placeholder={`${field.label}`}
                            disabled={field.visibility === "ReadOnly"}
                           
                            list="skuList"
                            autoComplete="off"
                            style={{
                              border: "1px solid #ddd",
                              position: "relative",
                            }}
                          />
                        ) : 
                      
                            field.type === "inputselect" ||
                              field.type === "dropdown" ||
                              field.type === "searchDropdown" ? (
                              <Controller
                                name={field.key}
                                control={control}
                                rules={{
                                  required:
                                    field?.mandatory &&
                                    field.visibility !== "ReadOnly" &&
                                    `${field.label} is required`,
                                }}
                                render={({
                                  field: controllerField,
                                }) => (
                                  <Select
                                    {...controllerField}
                                    options={
                                      field?.key
                                        ? getDropDownListAddStock({
                                            key: field?.key,
                                            branchOption,
                                            vendorList,
                                            skus,
                                            LotList,
                                            LotNumber,
                                            Vendor,
                                            SKUId,
                                          })
                                        : []
                                     
                                    }
                                    isDisabled={field.visibility === "ReadOnly"}
                                    isSearchable={
                                      field.type === "searchDropdown" ||
                                      field.type === "inputselect" ||
                                      field.type === "dropdown"
                                    }
                                    isClearable={true}
                                    placeholder="-- select --"
                                    styles={selectStyle}
                                  />
                                )}
                              />
                            ) : field.type === "number" ||
                              field.type === "text" ? (
                              <input
                                name={field.key}
                                type={field.type}
                                placeholder={`${field.label}`}
                
                             
                                style={{
                                  background: "white",
                                  border: "1px solid #ddd",
                                  height: "35px",
                                }}
                               
                                disabled={field.visibility === "ReadOnly"}
                              
                                {...register(field.key, {
                                  required:
                                    field?.mandatory &&
                                    field.visibility !== "ReadOnly" &&
                                    `${field.label} is required`,
                                })}
                                autoComplete="off"
                                
                                onKeyDown={(e) => {
                                  if (e?.code == "Enter") {
                                    e.preventDefault(); // Prevent form submission
                                  }
                                }}
                              />
                            ) : null}
                          </div>
                        </div>

                        {errors[field.key] && (
                          <span style={{ fontSize: "12px", color: "red" }}>
                            {errors[field.key].message}
                          </span>
                        )}
                      </div>
                   
                </>
              ))}
          </div>
        </div> */}

        {/* ----------- middle section ---------- */}

        {/* <div className={styles.linesection}>
          <div className={styles.middlecontainer}>
            {(stockType == "Labelled"
              ? itemfields
              : stockType == "Unlabelled"
              ? itemUnlabelledFields
              : []
            )
              ?.filter(
                (field) =>
                  field?.place === "middle" &&
                  field.visibility !== "Hidden" &&
                  field.IsVisible !== "Hidden"
              )
              ?.sort((a, b) => a.priority - b.priority)
              ?.map((field, index) => (
                <div className={styles.box}>
                  <div className={styles.box} key={field.key}>
                    <label title={field.label}>
                      {field.label.substring(0, 14)}{" "}
                      {field.label?.length > 14 && "..."}
                      {field?.mandatory && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </label>

                    {field.type == "inputselect" ||
                    field.type == "inputnumber" ||
                    field.type == "inputdecimal" ||
                    field.type == "inputtext" ? (
                      <input
                        type="text"
                        name={field.key}
                        disabled={field.key == "GrossWt"}
                        {...register(field.key, {
                          required:
                            field?.mandatory &&
                            field.visibility !== "ReadOnly" &&
                            `${field.label} is required`,
                        })}
                        autoComplete="off"
                        style={{
                          background: "white",
                          border: "1px solid #ddd",
                          height: "35px",
                        }}
                        render={({ field: controllerField }) => {
                          return (
                            <Select
                              {...controllerField}
                              options={generateDropDownList({
                                field,
                                dropdownListData,
                                CategoryId,
                                ProductId,
                                DesignId,
                                PurityId,
                                skus:[],
                                Vendor,
                                allCollections,
                                allPackets,
                                allBoxes,
                                vendorList,

                                mainStoneList,
                                weightCategoryList
                              })?.map((item) => ({
                                value: item?.value,
                                label: item?.label,
                              }))}
                              isDisabled={
                                field.visibility === "ReadOnly"
                                   ||
                                  ((field.key == "CategoryId" ||
                                    field.key == "ProductId" ||
                                    field.key == "DesignId" ||
                                    field.key == "PurityId")
                                    &&
                                    SKUId?.value
                                ) ||
                                (field?.key == "DiamondShape" && DiamondName?.value) || (field?.key == "DiamondColour" && DiamondName?.value) || (field?.key == "DiamondClarity" && DiamondName?.value)
                              }
                              isClearable={true}
                              isSearchable={field.type === "searchDropdown"}
                              styles={selectStylee}
                              
                            />
                          );
                        }}
                      />
                    ) : field.type === "dropdown" ||
                      field.type === "searchDropdown" ? (
                      <>
                        <Controller
                          name={field.key}
                          control={control}
                          rules={{
                            required:
                              field?.mandatory &&
                              field.visibility !== "ReadOnly" &&
                              `${field.label} is required`,
                            validate: (value) => {
                              if (
                                field?.mandatory &&
                                field.visibility !== "ReadOnly" &&
                                value?.value === ""
                              ) {
                                return `${field.label} cannot be empty`;
                              }
                            },
                          }}
                          render={({ field: controllerField }) => {
                            return (
                              <Select
                                {...controllerField}
                                options={generateDropDownList({
                                  field,
                                  dropdownListData,
                                  CategoryId,
                                  ProductId,
                                  DesignId,
                                  PurityId,
                                  skus: [],
                                  Vendor,
                                  allCollections,
                                  allPackets,
                                  allBoxes,
                                  vendorList,
                                  mainStoneList,
                                  weightCategoryList,
                                })?.map((item) => ({
                                  value: item?.value,
                                  label: item?.label,
                                }))}
                                isDisabled={
                                  field.visibility === "ReadOnly"
                                 
                                }
                                isClearable={true}
                                isSearchable={field.type === "searchDropdown"}
                                styles={selectStylee}
                                
                              />
                            );
                          }}
                        />
                      </>
                    ) : null}
                  </div>
                  {errors[field.key] && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors[field.key].message}
                    </span>
                  )}
                </div>
              ))}
          </div>
        </div>
       

        <div
          className={styles.custombarlinehead}
          style={{ marginBottom: "10px" }}
        >
          <div></div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button
              type="button"
              style={{
                padding: "4px 8px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                fontSize: "14px",
                backgroundColor: "#0077d4",
              }}
              onClick={handleAddSku}
            >
              {stockType === "Labelled" ? (
                <>
                  <Icon
                    style={{ fontSize: "24px" }}
                    icon="fluent:add-32-filled"
                  />
                  Add
                </>
              ) : (
                <>
                  <Check size={20} />
                  Save
                </>
              )}
            </button>
            <button
              type="button"
              style={{
                padding: "4px 8px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                fontSize: "12px",
                color: "#0077d4",
                backgroundColor: "#fff",
                border: "1px solid #0077d4",
              }}
              //   onClick={handleAddSku}
            >
              <Refresh size={20} />
              Reset
            </button>
            {stockType == "Unlabelled" && (
              <>
                <button
                  onClick={() => {
                    navigate(`/inventory_list`);
                  }}
                  type="button"
                  style={{
                    fontSize: "12px", // Smaller font size for responsiveness
                    backgroundColor: "#0077d4",
                    padding: "4px 6px", // Adjusted padding
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    flex: "1 1 auto",
                    minWidth: "100px",
                    maxWidth: "150px",
                  }}
                >
                  <Icon style={{ fontSize: "20px" }} icon="solar:list-bold" />{" "}
                  Labelled List
                </button>
                <button
                 
                  type="button"
                  style={{
                    fontSize: "12px", // Smaller font size for responsiveness
                    backgroundColor: "#0077d4",
                    padding: "4px 6px", // Adjusted padding
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    flex: "1 1 auto",
                    minWidth: "100px",
                    maxWidth: "150px",
                  }}
                >
                  <Icon style={{ fontSize: "20px" }} icon="solar:list-bold" />{" "}
                  Unlabelled List
                </button>
              </>
            )}
            {stockType != "Unlabelled" && (
              <button
                type="button"
                style={{
                  fontSize: "14px",
                  backgroundColor: "#0077d4",
                  padding: "4px 8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
                onClick={() => setIsFileUploadPopUp(true)}
              >
                <FileDownload size={20} />
                Import
              </button>
            )}
          </div>
        </div> */}

       
        {stockType != "Unlabelled" && (
          <StockTable
            itemfields={itemfields?.length ? itemfields : []}           
            styles={styles}
            dropdownListData={dropdownListData}
            allCollections={allCollections}
            allPackets={allPackets}
            allBoxes={allBoxes}
            selectStylee={selectStylee}
            stockData={stockData}
            ClientCode={clientCode}
            EmployeeCode={EmployeeCode}
            VendorName={Vendor}
            vendorTounchList={vendorTounchList}
            excelResponse={excelResponse}
            vendorList={vendorList}
            SKUId={SKUId}
            LotList={LotList}
            skuList={skuList}
            isDataFromExcel={isDataFromExcel}
          setMainStoneList={setMainStoneList}
          setWeightCategoryList={setWeightCategoryList}
          itemfieldsLooseDiamonds={itemfieldsLooseDiamonds?.length ? itemfieldsLooseDiamonds : []}
          />
        )}
      </form>
    </div>
  );
};

export default AddStockLabelledUnlabelled;
